import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker'
import { useEffect, useLayoutEffect, useState } from 'react'
import moment from 'moment'
import { makeStyles } from '@mui/styles'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  TextField,
  Typography
} from '@mui/material'

import DateIcon from '../../images/DateIcon.svg'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { allEvents } from '../../services/EventService'
import { EventStatus } from '../../services/Types'
import { convertMinutesIntoTime } from '../../services/Helper'
import { userData } from '../../services/AuthService'

export interface MobileDatePickerComponentProps {
  maximumDate?: Date
  minimumDate?: Date
  eventDate?: Date
  setEventDate?: any
  setLiveSlot?: any
  setDrySlot?: any
  setMinimumDryDate?: any
  blockedDates?: string[]
}

const useStyle = makeStyles({
  accordionRoot: {
    height: '40px'
  }
})

export const MobileDatePickerComponent: React.FC<MobileDatePickerComponentProps> =
  ({
    minimumDate = new Date(),
    eventDate,
    setEventDate,
    maximumDate,
    setLiveSlot,
    setDrySlot,
    setMinimumDryDate,
    blockedDates
  }) => {
    const disableDates = (date = new Date()): boolean => {
      if (blockedDates?.includes(moment(date).format('YYYY-MM-DD'))) return true
      return date.getDay() === 0 || date.getDay() === 6
    }

    const classes = useStyle()
    useLayoutEffect(() => {
      moment.locale('en', { day: (day: string) => day.charAt(0).toUpperCase() })
    }, [])

    const handleDateChange = (event: any) => {
      setEventDate(event)
      setExpanded(false)
      if (typeof setLiveSlot !== 'undefined') setLiveSlot('')
      if (typeof setDrySlot !== 'undefined') setDrySlot('')
      if (typeof setMinimumDryDate !== 'undefined') setMinimumDryDate(event)
    }

    const [expanded, setExpanded] = useState(false)

    const [events, setEvents] = useState<any>([])

    const getAllEvents = async () => {
      try {
        const { data } = await allEvents()
        if (data) {
          if (data.events.statusCode === 200) {
            const allBookingData: any[] = []

            data.events.data.forEach((value: any) => {
              value.roomBooking.forEach((booking: any) => {
                const eventDate = Number(booking.date)

                let eventBookingDate = moment.utc(eventDate)
                let startHours = Math.floor(booking.startTime / 60)
                let startMinutes = Math.floor(booking.startTime % 60)
                eventBookingDate.set({
                  hour: startHours,
                  minute: startMinutes
                })

                let eventEndDate = moment.utc(eventDate)
                let endHours = Math.floor(booking.endTime / 60)
                let endMinutes = Math.floor(booking.endTime % 60)
                eventEndDate.set({ hour: endHours, minute: endMinutes })
                let eventStatus = value.status
                const event: any = {
                  id: value.id,
                  createrId: value.createrId,
                  title: value.title,
                  description: value.description,
                  start: new Date(eventBookingDate.format().slice(0, -1)),
                  end: new Date(eventEndDate.format().slice(0, -1)),
                  startTime: convertMinutesIntoTime(booking.startTime),
                  endTime: convertMinutesIntoTime(booking.endTime),
                  category: booking.category,
                  status: eventStatus
                  //status : JSON.parse(userData).id !== value.createrId && (JSON.parse(user).role !== "ADMIN" && JSON.parse(user).role !== "APPROVER") ? 'ETA' : value.status
                }
                allBookingData.push(event)
              })
            })
            setEvents(allBookingData)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    useEffect(() => {
      // let allBookings:any[] = []

      const load = async () => {
        await getAllEvents()
      }
      load()
    }, [])

    let date = events.map((obj: { start: any }) => obj.start)
    return (
      <Box>
        <Accordion
          expanded={expanded}
          onChange={() => setExpanded(!expanded)}
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.2)',
            padding: '0px',
            position: 'absolute',
            zIndex: expanded ? 3 : 2,
            backgroundColor: 'white',
            '.css-yw020d-MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(180deg)!important'
            }
          }}
        >
          <AccordionSummary
            style={{ maxHeight: '40px', minHeight: '40px' }}
            expandIcon={
              <ArrowDropDownIcon style={{ color: 'rgba(0, 0, 0, 0.54)' }} />
            }
          >
            <Box
              style={{ width: '20px', height: '20px', marginRight: '14px' }}
              component='img'
              src={DateIcon}
              alt={DateIcon}
            />
            <Typography align='left' sx={{ fontSize: '16px' }}>
              {String(
                moment(eventDate).format('ddd') +
                  ' ' +
                  moment(eventDate).format('DD') +
                  ' ' +
                  moment(eventDate).format('MMM') +
                  ' ' +
                  moment(eventDate).format('YYYY')
              )}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: '0px', pb: '2px' }}>
              <CalendarPicker
                minDate={minimumDate}
                maxDate={maximumDate}
                date={eventDate}
                onChange={handleDateChange}
                shouldDisableDate={dateParam => disableDates(dateParam!)!}
              />
          </AccordionDetails>
        </Accordion>
      </Box>
    )
  }
